<template>
  <div class="app-page">
    <div class="app-card">
      <div class="app-card-title">承認一覧</div>
      <div class="app-header">
        <div class="app-selectors">
          <select class="form-control form-control-sm" v-model="selectedYear">
            <option v-for="(year, index) in years" :key="index" :value="year">{{ year }}年</option>
          </select>
          <select class="form-control form-control-sm" v-model="selectedMonth">
            <option v-for="(month, index) in months" :key="index" :value="month">{{ month }}月</option>
          </select>
        </div>
        <button class="view-toggle-btn" @click="isCalendarDisplay = !isCalendarDisplay">
          <i :class="isCalendarDisplay ? 'fas fa-list' : 'fas fa-calendar-alt'"></i>
        </button>
      </div>
      <TimecardCalendar :is-calendarDisplay="isCalendarDisplay" :is-application="true" :year="selectedYear" :month="selectedMonth - 1"></TimecardCalendar>
    </div>
  </div>
</template>

<script>
import TimecardCalendar from '../../components/TimecardCalendar.vue';

export default {
  data () {
    return {
      isCalendarDisplay: false,
      years: [],
      months: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      selectedYear: this.$moment().year(),
      selectedMonth: this.$moment().month() + 1,
    }
  },
  components: { TimecardCalendar },
  beforeMount() {
    const currentYear = this.$moment().year();
    for (let i = 0; i <= 10; i++) {
      this.years.push(currentYear - i);
    }
  },
}
</script>

<style>
.app-page {
  display: flex;
  justify-content: center;
  width: 100%;
}

.app-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.08);
  padding: 20px;
  width: 100%;
  max-width: 560px;
  box-sizing: border-box;
}

.app-card-title {
  font-size: 16px;
  font-weight: 700;
  color: #049C4C;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 2px solid #e2e8f0;
  display: block;
  width: 100%;
}

.app-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
}

.app-selectors {
  display: flex;
  gap: 8px;
}

.app-selectors select {
  width: auto;
  min-width: 100px;
  font-size: 15px;
  font-weight: 600;
  border-radius: 8px;
  border: 1.5px solid #d2d6dc;
  padding: 6px 28px 6px 10px;
  background: #fff;
  -webkit-appearance: none;
  appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23718096' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 8px center;
  overflow: visible;
  text-overflow: clip;
  height: auto;
}

.app-card .view-toggle-btn {
  width: 38px;
  height: 38px;
  border-radius: 8px;
  border: none;
  background: #049C4C;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.app-card .view-toggle-btn:hover {
  background: #038a42;
}
</style>
